/*global jQuery, google */
(function($) {

  'use strict';

  $(function() {
	  $('#filter-news-offerte').on('change', function(){
	  	var tipo = $(this).val();

	  	$('.newsofferta').addClass('d-none');
	  	$('.'+tipo).removeClass('d-none');

	  });

  });

}(jQuery));